<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p>To the memory of Dr Frank Rifkin, an irreplaceable friend and mentor</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?577b8cf4